import _stripTags from "../quill/stripTags.js";
const stripTags = _stripTags;
export default (function removeDuplicateBlankEvents(eventGroup, frameRate) {
  const events = eventGroup.events;
  let i = 0;
  while (i < events.length) {
    const event = events[i];
    const isBlank = stripTags(event.text.trim()).trim() === "";
    if (isBlank) {
      const previousEvent = events[i - 1];
      if (previousEvent && ["Pop-On", "Paint-On"].indexOf(previousEvent.style) > -1) {
        events.splice(i, 1);
        continue;
      }

      // Look ahead to find all consecutive blank events
      let j = i + 1;
      while (j < events.length && stripTags(events[j].text.trim()).trim() === "") {
        j++;
      }

      // If there are multiple consecutive blank events (j > i + 1)
      if (j > i + 1) {
        // Set the first blank event to be 1 frame long
        events[i].end = events[i].start + 1 / frameRate;

        // Remove all subsequent blank events
        events.splice(i + 1, j - i - 1);
      }
      i++;
    } else {
      i++;
    }
  }
  return eventGroup;
});